let defaultMask = '9999 9999 9999 9999';
let americanExpressMask = '9999 999999 99999';

export const CreditCardBrand = {
	'visa': {
		mask: defaultMask,
		image: '/static/credit-cards/visa.png',
		color: 'dark-blue',
		brand: {id: 1, name: 'Visa'}
	},
	'mastercard': {
		mask: defaultMask,
		image: '/static/credit-cards/mastercard.png',
		color: 'bright-blue',
		brand: {id: 2, name: 'Master'}
	},
	'american-express': {
		mask: americanExpressMask,
		image: '/static/credit-cards/amex.png',
		color: 'dark-green',
		brand: {id: 3, name: 'Amex'}
	},
	'elo': {
		mask: defaultMask,
		image: '/static/credit-cards/elo.png',
		color: 'green',
		brand: {id: 4, name: 'Elo'}
	}
}



// WEBPACK FOOTER //
// ./src/enums/CreditCardBrand.js